export default __webpack_public_path__ + "static/play-agent2-bop-english-76f7206b54b3d50c711dad9c617e9403.png";